/* global Vue, axios */

import Vue from 'vue';

import Literature from "./components/Literature";
import LiteratureCartExternal from "./components/LiteratureCartExternal";

Drupal.behaviors.literature = {
  attach: function (context, settings) {
    // ------------------------
    // Literature Shopping Cart
    if (context !== document) {
      return;
    }



    if (typeof Vue !== 'undefined' && context === document) {
      new Vue({
        el: '#literature-app',
        components: { 'literature': Literature },
        // render: h => h(Literature),
        // props: {
        // },
      });

      new Vue({
        el: '#extra-content',
        render: (h) => h(LiteratureCartExternal),
        props: {
        },
      })

    }
  }
}


